import { categories } from "@/mocks/categories";

const featuredIndices = [0, 1, 2]; // Shoes, Hoodies, T-Shirts

export default function FeaturedCategories() {
  const featured = featuredIndices.map((i) => categories[i]);

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        {/* Section Title */}
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Smart Shopping{" "}
            <span className="text-secondary-500">Categories</span>
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-md mx-auto">
            Jump straight to the most popular product categories
          </p>
        </div>

        {/* Featured Grid */}
        <div className="flex flex-col lg:flex-row gap-4 max-w-5xl mx-auto">
          {/* Large left card - Shoes */}
          <a
            href={featured[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="lg:w-1/2 h-80 md:h-96 rounded-2xl overflow-hidden relative group cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Chunky%20platform%20dad%20sneakers%20standing%20on%20polished%20concrete%20floor%20against%20neon%20pink%20and%20blue%20gradient%20wall%2C%20cyberpunk%20aesthetic%2C%20dramatic%20studio%20lighting%20with%20colored%20gels%2C%20modern%20streetwear%20editorial%2C%20high%20fashion%20product%20photography&width=800&height=960&seq=feat-shoes-v2-01&orientation=portrait"
              alt="Shoes"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-5 left-5">
              <span className="inline-block px-4 py-2 bg-background-50/90 backdrop-blur-sm rounded-lg text-foreground-900 font-semibold text-sm">
                {featured[0].name}
              </span>
            </div>
          </a>

          {/* Right stacked cards */}
          <div className="lg:w-1/2 flex flex-col gap-4">
            <a
              href={featured[1].url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-1 h-44 md:h-[184px] rounded-2xl overflow-hidden relative group cursor-pointer bg-secondary-50"
            >
              <div className="flex items-center h-full">
                <div className="w-1/2 flex items-center justify-center p-6">
                  <img
                    src="https://readdy.ai/api/search-image?query=Neon%20green%20oversized%20hoodie%20folded%20on%20reflective%20black%20acrylic%20surface%20with%20purple%20and%20pink%20neon%20tube%20lights%20reflecting%20around%20it%2C%20night%20club%20aesthetic%2C%20futuristic%20cyber%20fashion%20photography%2C%20vibrant%20electric%20colors%2C%20glossy%20reflections&width=400&height=400&seq=feat-hoodie-v2-02&orientation=squarish"
                    alt="Hoodie"
                    className={`w-full h-full object-contain group-hover:scale-105 transition-transform duration-500`}
                  />
                </div>
                <div className="w-1/2 flex flex-col justify-center pr-6">
                  <span className="font-heading text-xl font-semibold text-foreground-900">
                    {featured[1].name}
                  </span>
                  <span className="text-xs text-foreground-500 mt-1">Open Sheet →</span>
                </div>
              </div>
            </a>

            <a
              href={featured[2].url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-1 h-44 md:h-[184px] rounded-2xl overflow-hidden relative group cursor-pointer bg-primary-50"
            >
              <div className="flex items-center h-full">
                <div className="w-1/2 flex items-center justify-center p-6">
                  <img
                    src="https://readdy.ai/api/search-image?query=Oversized%20vintage%20washed%20t-shirt%20draped%20over%20driftwood%20log%20on%20sandy%20beach%20with%20turquoise%20ocean%20waves%20behind%2C%20tropical%20coastal%20aesthetic%2C%20bright%20midday%20sunlight%2C%20relaxed%20vacation%20lifestyle%20photography%2C%20vivid%20blue%20and%20beige%20palette&width=400&height=400&seq=feat-tshirt-v2-03&orientation=squarish"
                    alt="T-Shirt"
                    className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="w-1/2 flex flex-col justify-center pr-6">
                  <span className="font-heading text-xl font-semibold text-foreground-900">
                    {featured[2].name}
                  </span>
                  <span className="text-xs text-foreground-500 mt-1">Open Sheet →</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}